import toastr from "toastr";
import 'toastr/build/toastr.min.css';
import * as Menu from "/app/js/common/Menu.js";

export const load = function (target, url, isAppend, prepend) {
    url = "app/html/"+url;

    return new Promise(function (resolve, reject) {
        if (target) {
            fetch(url)
                .then(response => response.text())
                .then(text => {
                    if (isAppend) {
                        if (prepend) {
                            target.insertAdjacentHTML('afterbegin', text);
                        } else {
                            target.insertAdjacentHTML('beforeend', text);
                        }
                    } else {
                        target.innerHTML = '';
                        target.insertAdjacentHTML('afterbegin', text);
                    }
                    resolve(target);
                })
                .catch(error => {
                    reject(error);
                });
        } else {
            reject('target element is not found');
        }
    });
}

/**
 * opt
 * html : string : html 경로
 * title : string : 타이틀바 제목
 * modal : boolean : modal 여부 // true : 모달 뒤 반응x, false : 모달 뒤 반응o
 * dialogClass : string : class
 * width : int : dialog width
 * resizable : boolean : resize여부
 * draggable : boolean : 제목 표시줄을 클릭하고 움직일 수 있는지 여부
 * position : { my: "자신의 위치", at: "기점이 되는 요소 상의 위치", of: "기점이 되는 요소(셀렉터 or jquery요소)" }
 * buttons : array : dialog button
 * open : function : dialog open 시 함수(생략가능)
 * close : function : dialog close 시 함수(생략가능)
 */
export const openDialog = function(opt) {
    const key = "o2-" + o2.util.String.generateUUIDv4();

    let dialogEl = document.createElement(  'div');
    dialogEl.id = key;
    dialogEl.classList.add('pop-body');

    if(opt.contentEl !== undefined){
        dialogEl.appendChild(opt.contentEl);
    }
    if(o2.util.Common.defined(opt.resizable) === false){
        opt.resizable = false;
    }
    if(o2.util.Common.defined(opt.resizable) === false){
        opt.resizable = true;
    }
    if(o2.util.Common.defined(opt.draggable) === false){
        opt.draggable = true;
    }

    document.querySelector('body').appendChild(dialogEl);

    let $DLG_UI = $('#'+key);

    if(opt.html === undefined){
        $DLG_UI.dialog(opt);
    }else{

        load(document.querySelector('#' + key), opt.html).then(function(){
            $DLG_UI.dialog(opt);
        });
    }
    return $DLG_UI;
}

/**
 * msg : string : 띄울 메세지
 * type : string : info, alert, error
 * interval : int : 유지시간
 */
export const msgBox = function(msg, type, interval = 3000) {
    if (o2.util.Common.isEmpty(msg) === true) return;

    // 유지시간 설정
    const originalInterval = toastr.options.timeOut;
    toastr.options.timeOut = interval;

    switch(type) {
        case 'success':
            toastr.success(msg);
            break;
        case 'error':
            toastr.error(msg);
            break;
        case 'warning':
        case 'alert':
            toastr.warning(msg);
            break;
        case 'info' :
        default:
            toastr.info(msg);
            break;
    }

    // 유지시간 되돌리기
    toastr.options.timeOut = originalInterval;
}

/**
 * $parentEl 하위 마지막 순서로 html 요소 추가 후 생성한 요소 반환
 * ** fragment에 그냥 붙일 경우 tr, th 등 사라지는 태그가 있어서 template에 붙여서 사용
 * @param html
 * @param $parentEl
 * @returns 생성한 요소
 */
export const appendHtml = function (html, $parentEl) {
    const $tmp = document.createElement("template");
    $tmp.innerHTML = html;

    const fragment = document.createDocumentFragment();
    fragment.append(...$tmp.content.childNodes);

    const nodeList = Object.extend([], fragment.childNodes);

    $parentEl.append(fragment);

    return nodeList;
}

export const datepicker = function(el, opt){

    if(!(el instanceof jQuery)){
        el = $(el);
    }

    let defaultOption = {
        showOn: "both",
        buttonImage: "app/images/ico_calendar.png",
        buttonImageOnly: true,
        dayNames: [ "일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일" ],
        dayNamesMin: [ "일", "월", "화", "수", "목", "금", "토" ],
        dayNamesShort: [ "일", "월", "화", "수", "목", "금", "토" ],
        monthNames: [ "1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월" ],
        monthNamesShort: [ "1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월" ],
        closeText: '닫기',
        weekHeader: '주',
        dateFormat: 'yy-mm-dd',
        isRTL: false,
        showMonthAfterYear: true,
        yearSuffix: '년'
    };
    if(o2.util.Common.defined(opt) === true){
        opt = Object.assign(defaultOption, opt);
    }else {
        opt = defaultOption;
    }

    if(el.hasClass("startDt")) {
        let startOption = {
            onClose: function(selectedDate) {
                let dateBox = this.parentElement.parentElement;
                let startDt = Number( dateBox.querySelector(".startDt").value.replace(/[-./]/g,'') );
                let endDt = Number( dateBox.querySelector(".endDt").value.replace(/[-./]/g,'') );
                if(startDt !== 0 && endDt !== 0){
                    if(startDt > endDt){
                        toastr.warning("시작일은 종료일보다 이전이여야 합니다.");
                        el.val("");
                        return false;
                    }
                }
            },
        }
        opt = Object.assign(startOption, opt);
        el.datepicker(opt);
    } else if(el.hasClass("endDt")){
        let endOption = {
            onClose: function(selectedDate) {
                let dateBox = this.parentElement.parentElement;
                let startDt = Number( dateBox.querySelector(".startDt").value.replace(/[-./]/g,'') )
                let endDt = Number( dateBox.querySelector(".endDt").value.replace(/[-./]/g,'') )
                if(startDt != 0 && endDt != 0){
                    if(startDt > endDt){
                        toastr.warning("종료일은 시작일보다 이후여야 합니다.");
                        el.val("");
                        return false;
                    }
                }
            },
        }
        opt = Object.assign(endOption, opt);
        el.datepicker(opt);
    } else {
        el.datepicker(opt);
    }
}


/*
 * opt
 * min : int : slider 최소값
 * max : int : slider 최대값
 * values : array : slider 초기 setting값
 */
export const slider = function(el, target, opt){
    let _map = null;
    let resolutions = null;

    el = $(el);

    // const prevSlider = el.find(target).slider("instance");
    // if(o2.util.Common.defined(prevSlider)){
    //     el.find(target).slider("destroy");
    // }

    if(o2.util.Common.defined(opt.isStyle)){
        if(o2.util.Common.defined(opt.map)){
            _map= opt.map;
            resolutions = _map.getView().getResolutions();
        }
        el.find(target).slider({
            range : true,
            min : opt.min,
            max : opt.max,
            values : opt.values,
            slide : function(event, ui){
                const minValue = ui.values[0];
                const maxValue = ui.values[1]

                el.find('.slider-range span:eq(0)')[0].textContent = minValue;
                el.find('.slider-range span:eq(1)')[0].textContent = maxValue;

                const resolution = resolutions[ui.value]
                const scale = _map.getScaleFromResolution(resolution);

                const styleText = "width:80px; margin-left:-30px;";
                $(ui.handle).append('<div class="slider-range-tooltip" style="'+styleText + '">'+ "1:"+scale.toFixed() +'</div>'); // add tooltop
            },
            create : function(event, ui){
                let values = $(this).slider("values");

                el.find('.slider-range span:eq(0)').text(values[0]);
                el.find('.slider-range span:eq(1)').text(values[1]);

                el.find(target).find(".ui-slider-handle").append('<div class="slider-range-tooltip"></div>'); // add tooltop
            }
        });
    }else{
        el.find(target).slider({
            range : true,
            min : opt.min,
            max : opt.max,
            values : opt.values,
            slide : function(event, ui){
                el.find('.slider-range span:eq(0)').text(ui.values[0]);
                el.find('.slider-range span:eq(1)').text(ui.values[1]);
            },
            create : function(event, ui){
                let values = $(this).slider("values");

                el.find('.slider-range span:eq(0)').text(values[0]);
                el.find('.slider-range span:eq(1)').text(values[1]);
            }
        });
    }
}

export const opacitySlider = function (el, callback, opt = {}) {
    const $el = $(el);
    const value = opt.value ?? 100;
    $el.slider({
        min: opt.min ?? 0,
        max: opt.max ?? 100,
        value: value,
        create: function (event, ui) {
            $el.append(`<span class="slider-range" style="width: ${value}%;"></span>`);
            $el.find('.ui-slider-handle').addClass('slider-bar');
        },
        slide: function (event, ui) {
            $el.find('.slider-range').css('width', `${ui.value}%`);
            const opacity = Number(ui.value) / 100;
            callback(opacity);
        },
    });
}

/**
 * opt
 * title : string : alert창 타이틀바에 출력될 문구
 * text : string : alert창에 출력될 문구
 * okFunc : function : ok버튼 클릭 시 호출되는 함수
 * cancelFunc : function : cancel버튼 클릭 시 호출되는 함수
 */

export const openConfirm = function (opt) {

    let cancelFunc = function () {
        $(this).dialog("destroy").remove();
    }

    if (o2.util.Common.defined(opt.cancelFunc) === true) {
        cancelFunc = function () {
            opt.cancelFunc();
            $(this).dialog("destroy").remove(); // 추가된 부분
        }
    }

    let okFunc = function () {
        $(this).dialog("destroy").remove();
    }

    if (o2.util.Common.defined(opt.okFunc) === true) {
        okFunc = function () {
            opt.okFunc();
            $(this).dialog("destroy").remove();
        }
    }

    let defaultOpt = {
        title: opt.title,
        modal: true,
        dialogClass: 'pop-box open-confirm',
        minHeight: 0,
        resizable: false,
        buttons: [
            {
                text: '확인',
                "class": "btn point",
                click: okFunc
            },
            {
                text: '닫기',
                "class": "btn",
                click: cancelFunc
            }
        ],
        text: opt.text,
        close: cancelFunc
    }

    if (o2.util.Common.defined(opt.width)) {
        defaultOpt.width = opt.width;
    }
    if (o2.util.Common.defined(opt.height)) {
        defaultOpt.height = opt.height;
    }

    let contentEl = document.createElement('p');
    contentEl.insertAdjacentHTML("beforeend", defaultOpt.text);

    defaultOpt.contentEl = contentEl;

    openDialog(defaultOpt);
}

/**
 * opt
 * title : string : alert창 타이틀바에 출력될 문구
 * text : string : alert창에 출력될 문구
 */
export const openAlert = function(opt) {

    let defaultOpt = {
        title : opt.title,
        modal : true,
        dialogClass : 'pop-box open-alert',
        minHeight : 0,
        resizable : false,
        buttons : [
            {
                text : '닫기',
                "class" : "btn",
                click : function(){
                    $(this).dialog("close");
                }
            }
        ],
        close : function(){
            $(this).dialog("destroy").remove();
        },
        text : opt.text
    }

    let contentEl = document.createElement('p');
    contentEl.insertAdjacentHTML("beforeend",defaultOpt.text);

    defaultOpt.contentEl = contentEl;

    return openDialog(defaultOpt);
}

/**
 * key : string : ENG, KOR
 * initMenu : boolean : true - 메뉴 초기화, false - 메뉴 초기화 안함. 문자만 바꿈
 */
export const changeLang = async function (key, initMenu) {

    const changeLangKey = key === 'KOR' ? 'ko' : 'en';

    localStorage.setItem('lang', key);

    document.documentElement.lang = changeLangKey;

    const activeMenuKey = Menu.getActiveMenuKey();

    if(initMenu) await Menu.openMenu(activeMenuKey);

    //모든 element를 찾아서 attribute의 en-text, ko-text 중에 key와 일치하는 text를 가져와서 변경한다.
    const elements = document.querySelectorAll('[en-text], [ko-text]');
    elements.forEach(element => {
        const text = element.getAttribute(changeLangKey + '-text');
        if (text) {
            element.innerText = text;
        }
    });

}

export const clearPage = async function(goToMain){

    document.querySelector("#wrap").innerHTML = '';

    document.querySelector('#wrap').classList.remove('sub');
    document.querySelector('#wrap').classList.remove('main');


    if(goToMain){
        document.querySelector('link[href*="sub.css"]').disabled = true;
        document.querySelector('#wrap').classList.add('main');
        document.body.style.overflowY = 'hidden';
    }else {
        document.querySelector('link[href*="sub.css"]').disabled = false;
        document.querySelector('#wrap').classList.add('sub');
        document.body.style.overflowY = '';
    }
}

export const initCommonUI = function () {

    //메인화면 및 헤더 스크립트 - 퍼블리싱 활용. 묶여있어서 여기에 둠
    const geoUI = (function (ui, $j, $window, $body) {
        // 1. UI 초기화
        ui.init = function () {
            ui.common.init(); // 공통 기능 초기화
            ui.gnb.init();    // GNB(Great Navigation Bar) 초기화
            ui.main.init(); // 메인화면 존재 시 초기화
        };

        /*
        1. ui.common: 공통적인 기능 (탑버튼)
        2. ui.gnb: GNB 관련 기능 (PC와 모바일 분리 처리)
        3. ui.main: 메인화면의 슬라이더, 섹션 전환
        *** 조건에 따라 main 또는 layer를 초기화
        .*/

        /**--------------------------------- 공통 기능 */
        ui.common = {
            //탑버튼 최상단 올리기
            init: function(){
                this._pageTop();
            },
            _pageTop: function(){
                let $btn = $j('footer .btnTop'),
                    $obj = $j('html, body');
                $btn.on('click', function() {
                    $obj.animate({scrollTop: 0});
                });
            }
        };

        /**--------------------------------- gnb 기능 */
        ui.gnb = {
            $wrap: $j('#wrap'),
            $header: $j(".headerWrap"),
            $section: $j(".sub-section product"),
            $nav: $j('nav'),
            $items:  $j('.gnbWrap > li'),
            $subItems: $j('.dep2Gnb'),
            $obj: $j('.gnbWrap > li.on > .dep2Gnb'),
            $fullscreen: $j('.fullscreen-menu'),
            st: null,
            _isPc: true,
            _isMo: true,
            init: function(){
                this._chkMo() ? this._mo() : this._pc();  // 모바일 여부에 따라 초기화
                this._resize(); // 화면 크기 변경 대응
                this._open(); // GNB 열기
                this._close(); // GNB 닫기
                this._allOpen();  // 풀스크린 메뉴 열기
            },
            _pc: function() {
                if (this._isPc) {
                    this._isPc = false;
                    this._isMo = true;
                    this.$wrap.addClass('pc').removeClass('mo');
                    // #wrap에 .sub 클래스가 없을 경우에만 $body 스타일 적용
                    if (!this.$wrap.hasClass('sub')) {
                        $body.css({ 'height': $window.innerHeight(), 'overflow': 'hidden' });
                    }
                    ui.gnb.$header.find('.dep2Gnb').hide();
                    ui.gnb.$header.find('nav').show();
                    this.$items.unbind('click');
                    ui.gnb.$wrap.find('.indicator').show();
                    ui.main._evt();
                    this.$items.hover(function() {
                        ui.gnb.$header.addClass("on");
                        ui.gnb.$subItems.addClass("on");
                        if ($j('.dep2Gnb').hasClass('on')) {
                            $j('.dep2Gnb').css({ 'display': 'flex' });
                        } else {
                            $j('.dep2Gnb').css({ 'display': 'none' });
                        }
                    });
                    this.$header.on('mouseleave', function() {
                        ui.gnb.$header.removeClass("on");
                        ui.gnb.$items.removeClass('on');
                        ui.gnb.$subItems.removeClass('on');
                        ui.gnb.$subItems.css({ 'display': 'none' });
                    });
                    ui.gnb.$header.find('.mainMenu').addClass("on");
                }
            },
            _mo: function(){
                if(this._isMo){
                    this._isMo = false,
                        this._isPc = true;
                    this.$wrap.addClass('mo').removeClass('pc');// PC 모드로 전환
                    ui.gnb.$header.find('nav').hide();
                    ui.gnb.$fullscreen.css({"display":"none"});
                    ui.gnb.$wrap.find('.indicator').hide();
                    this.$items.unbind('mouseenter mouseleave');
                    this.$header.unbind('mouseleave');
                    $window.off('mousewheel');
                    $body.css({'height': 'auto', 'overflow':'visible'});
                    this.$items.on('click', function(){
                        if($j(this).hasClass('on')){
                            $j(this).removeClass('on').find(ui.gnb.$subItems).slideUp(500);
                        } else {
                            $j(this).addClass('on').find(ui.gnb.$subItems).slideDown(500).end().siblings(ui.gnb.$items).removeClass('on').find(ui.gnb.$subItems).slideUp(500);
                        };
                    });
                };
            },
            _open: function(){
                let $openBtn = $body.find('.btnGnb');
                $openBtn.on('click', function(){
                    ui.gnb.$header.find('nav').fadeIn();
                    $body.find('.btnGnbClose').css({'display':'block'})
                    $body.css({'height': $window.innerHeight(), 'overflow':'hidden'});
                    ui.gnb.st = $window.scrollTop();
                });
            },
            _close: function(){
                let $closeBtn = $body.find('.btnGnbClose');
                $closeBtn.on('click', function(){
                    ui.gnb.$header.find('nav').fadeOut();
                    ui.gnb.$items.removeClass('on').find('ul').hide();
                    $body.css({'height': 'auto', 'overflow':'visible'});
                    $window.scrollTop(ui.gnb.st);
                });
            },
            _resize: function(){
                $window.on('resize', function(){
                    ui.gnb._chkMo() ? ui.gnb._mo() : ui.gnb._pc();
                    // 화면 크기 변화 시 재설정
                });
            },
            _chkMo: function(){
                // window.scrollTo(0,0);
                return $window.innerWidth() < 1201 ? true : false;
                // 1200px 이하일 때 모바일로 간주
            },
            _allOpen: function(){
                $('.mainMenu').on('click', function(){
                    $('.fullscreen-menu').fadeIn(100);
                    $('.fullscreen-menu').on('scroll touchmove mousewheel', function(e){
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    })
                });
                $('.btn-close').on('click', function(){
                    $('.fullscreen-menu').fadeOut(100);
                });
            },
        }

        /**--------------------------------- main 기능 */
        ui.main ={
            _oldIdx: 0,
            _curIdx: 1,
            _isAnim: true,
            $main: null,
            $obj: null,
            $objLeng: null,
            $footer: null,
            $indicator: null,
            $scrollBar: null,
            init: function(){
                if ($j('#wrap').hasClass('sub')) {
                    // console.log("ui.main 기능이 중단되었습니다: .sub 클래스 감지");
                    return;
                }
                this._set();
                this._evt();
                this._indicator();
                this._top();
                this._slide();
            },
            _set: function(){
                this.$main = $j('main'),
                    this.$obj = $j('> section', this.$main),
                    this.$objLeng = this.$obj.length,
                    this.$footer = $j('footer'),
                    this.$indicator = $j('.indicator'),
                    this.$scrollBar = $j('.scrollAction');
            },
            _evt: function(){
                $j(document).on('wheel DOMMouseScroll', function(e){
                    let d = e.originalEvent.wheelDelta;
                    if(!ui.gnb._isPc){
                        d < 0 ? ui.main._down() : ui.main._up();
                    }else {
                    }
                });
            },
            _up: function(i){
                if(ui.main._isAnim){
                    if(this._oldIdx !== 0){
                        this._curIdx = this._oldIdx--;
                        i >= 0 ?  this._oldIdx = i : this._oldIdx;
                        this.$indicator.find('li').eq(this._oldIdx).find('button').addClass('active').closest('li').siblings('li').find('button').removeClass('active');
                        this.$obj.eq(this._curIdx).animate({'top':'100%'}, 700);
                        this.$obj.eq(this._oldIdx).css({'top': '-100%'}).animate({'top':'0'}, 700);
                        ui.main._isAnim = false;
                        this._checkAnim();
                        this._curIdx = this._oldIdx;
                        this._oldIdx = this._curIdx++;
                    };
                };
            },
            _down: function(i){
                if(ui.main._isAnim){
                    if(this.$objLeng > this._curIdx){
                        this._curIdx = i || this._curIdx;
                        this.$indicator.find('li').eq(this._curIdx).find('button').addClass('active').closest('li').siblings('li').find('button').removeClass('active');
                        this.$obj.eq(this._oldIdx).animate({'top':'-100%'}, 700);
                        this.$obj.eq(this._curIdx).css({'top': '100%'}).animate({'top':'0'}, 700);
                        this._oldIdx = this._curIdx;
                        this._curIdx++;
                        ui.main._isAnim = false;
                        this._checkAnim();
                    };
                };
            },
            _indicator: function(){
                for(let i = 0; i < this.$objLeng; i++){
                    this.$indicator.append('<li><button class="">'+ (i + 1) +'번째 섹션으로 이동</button></li>');
                };
                $j('li', this.$indicator).eq(0).find('button').addClass('active');
                let $items = $j('li button', this.$indicator);
                $items.on('click', function(){
                    let $this = $j(this),
                        i = $this.parent('li').index();
                    $this.addClass('active').closest('li').siblings('li').find('button').removeClass('active');
                    ui.main.$footer.removeClass('on');
                    ui.main._isAnim = true;
                    if (i < ui.main._oldIdx){
                        ui.main._up(i);
                    } else if(i > ui.main._oldIdx){
                        ui.main._down(i);
                    } else {
                        return false;
                    };
                });
            },
            _color: function(n){
                if( n%2 > 0){
                    this.$indicator.addClass('bk');
                    this.$scrollBar.addClass('bk');
                    ui.gnb.$header.addClass('active');
                } else {
                    this.$indicator.removeClass('bk');
                    this.$scrollBar.removeClass('bk');
                    ui.gnb.$header.removeClass('active');
                }
            },
            _top: function(){
                let $top = $j('.btnTop');
                $top.on('click', function(){
                    ui.main.$footer.removeClass('on');
                    ui.main._isAnim = true;
                    ui.main._up(0);
                });
            },
            _checkAnim: function(){
                this._color(this._oldIdx);
                setTimeout(function(){
                    ui.main._isAnim = true;
                }, 700);
            },
            _slide: function(){
                const $slider = $('.slider');
                if (!$slider.length) {
                    return;
                }

                const $counter = $('.slider-container .counter');
                const $current = $counter.find('.current');
                const $total = $counter.find('.total');
                let currentIndex = 0;

                const getTotalSlides = () => $slider.find('.slide').length;

                const clampIndex = () => {
                    const total = getTotalSlides();
                    if (total === 0) {
                        currentIndex = 0;
                    } else if (currentIndex > total - 1) {
                        currentIndex = total - 1;
                    } else if (currentIndex < 0) {
                        currentIndex = 0;
                    }
                    return total;
                };

                const render = () => {
                    const total = clampIndex();
                    const offset = total ? -currentIndex * 100 : 0;
                    $slider.css('transform', `translateX(${offset}%)`);
                    if ($current.length) {
                        $current.text(total ? currentIndex + 1 : 0);
                    }
                    if ($total.length) {
                        $total.text(total);
                    }
                };

                const goNext = () => {
                    const total = clampIndex();
                    if (currentIndex < total - 1) {
                        currentIndex++;
                        render();
                    }
                };

                const goPrev = () => {
                    if (currentIndex > 0) {
                        currentIndex--;
                        render();
                    }
                };

                $('.next').off('click.cardNews').on('click.cardNews', goNext);
                $('.prev').off('click.cardNews').on('click.cardNews', goPrev);

                if (typeof MutationObserver !== 'undefined' && $slider.get(0)) {
                    const observer = new MutationObserver(() => {
                        render();
                    });
                    observer.observe($slider.get(0), { childList: true });
                }

                render();
            },
        }
        ui.init();
        return ui;
    }(window.geoUI || {}, jQuery, $(window), $('body')));

    /**
     * 요소가 화면에 보여짐 여부에 따른 요소 관리
     */
// 관리할 요소들 검색!
    const spyEls = document.querySelectorAll("section.scroll-spy");
// 요소들 반복 처리!
    spyEls.forEach((spyEl) => {
        new ScrollMagic.Scene({
            // 감시할 장면(Scene)을 추가
            triggerElement: spyEl, // 보여짐 여부를 감시할 요소를 지정
            triggerHook: 0.8, // 화면의 80% 지점에서 보여짐 여부 감시
        })
            .setClassToggle(spyEl, "show") // 요소가 화면에 보이면 show 클래스 추가
            .addTo(new ScrollMagic.Controller()); // 컨트롤러에 장면을 할당(필수!)
    });
}
